module.exports = __webpack_public_path__ + "static/fonts/Linearicons-Free.03e91f1.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Linearicons-Free.woff2?w118d
// module id = 75EO
// module chunks = 1